import apiClient from 'api';

export const client = {
  all: async (): Promise<ServiceResponse<Category[]>> => apiClient.retrieve<Category[]>({
    url: '/categories',
    method: 'get',
  }),
};

export default client;